import { createRoot } from 'react-dom/client';
import App from './editor/App';

// The Shopify theme provides the mount point (it has always been #root).
const el = document.getElementById('tm-designer') ?? document.getElementById('root');
if (el) createRoot(el).render(<App />);
